import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5740ebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "hist" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-clipboard-list fa-fw" }, null, -1))
const _hoisted_3 = {
  class: "card-header",
  style: {"color":"#606266","display":"flex","justify-content":"space-around","align-items":"center"}
}
const _hoisted_4 = {
  class: "demo-image__preview",
  style: {"display":"inline-flex"}
}
const _hoisted_5 = { class: "image-slot" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2画像（表裏）までアップロードできます。", -1))
const _hoisted_7 = {
  class: "el-upload-list el-upload-list--picture-card",
  style: {"display":"inline-flex"}
}
const _hoisted_8 = ["onMouseover", "onMouseleave"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "el-upload-list__item is-success" }
const _hoisted_11 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_UploadFilled = _resolveComponent("UploadFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Picture = _resolveComponent("Picture")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_hist_area_tbl = _resolveComponent("hist-area-tbl")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_DeleteFilled = _resolveComponent("DeleteFilled")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, null, {
          default: _withCtx(() => [
            _hoisted_2,
            _createTextVNode(" 発注管理（反響管理）")
          ]),
          _: 1
        }),
        _createVNode(_component_el_main, null, {
          default: _withCtx(() => [
            (_ctx.message.err)
              ? (_openBlock(), _createBlock(_component_el_alert, {
                  key: 0,
                  title: _ctx.message.msg,
                  type: "error"
                }, null, 8, ["title"]))
              : _createCommentVNode("", true),
            _createVNode(_component_el_card, { class: "box-card" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("span", null, "発注番号 " + _toDisplayString(_ctx.orderInfo['order_id']), 1),
                  _createVNode(_component_el_divider, { direction: "vertical" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo['dweek']), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.distributeWay[_ctx.orderInfo['segment']]) + "配布", 1),
                  _createVNode(_component_el_divider, { direction: "vertical" }),
                  _createElementVNode("span", null, _toDisplayString(_ctx.orderInfo['size']), 1),
                  _createVNode(_component_el_divider, { direction: "vertical" }),
                  _createElementVNode("span", null, _toDisplayString(Number(_ctx.orderInfo['order_qty']).toLocaleString()) + "部", 1),
                  _createVNode(_component_el_divider, { direction: "vertical" }),
                  _createElementVNode("span", null, "金額 " + _toDisplayString(Number(_ctx.orderInfo['order_price']).toLocaleString()) + "円（税別）", 1),
                  _createVNode(_component_el_divider, { direction: "vertical" }),
                  _createElementVNode("span", null, "発注日 " + _toDisplayString(_ctx.orderInfo['order_date']), 1),
                  _createVNode(_component_el_tooltip, {
                    class: "item",
                    effect: "dark",
                    content: "チラシ画像アップロード",
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        size: "mini",
                        circle: "",
                        onClick: _ctx.uplDialog
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_UploadFilled)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_image, {
                      style: {"width":"30px","height":"30px"},
                      src: _ctx.url,
                      "preview-src-list": _ctx.srcList
                    }, {
                      error: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_Picture)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["src", "preview-src-list"])
                  ])
                ])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_hist_area_tbl, {
                  arealist: _ctx.areaList,
                  loading: _ctx.loading
                }, null, 8, ["arealist", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_footer, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "success",
              onClick: _ctx.updFeedback
            }, {
              default: _withCtx(() => [
                _createTextVNode("更新")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _ctx.back
            }, {
              default: _withCtx(() => [
                _createTextVNode("戻る")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      title: "画像アップロード",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      width: "355px"
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("ul", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.srcList, (img, idx) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "el-upload-list__item is-success",
              key: idx,
              onMouseover: ($event: any) => (_ctx.handleImgHover(idx)),
              onMouseleave: ($event: any) => (_ctx.handleImgLeave(idx))
            }, [
              _createVNode(_component_el_image, {
                style: {"width":"148px","height":"148px"},
                src: img,
                fit: "cover"
              }, null, 8, ["src"]),
              _withDirectives(_createElementVNode("span", {
                class: "overray",
                onClick: ($event: any) => (_ctx.handleDelete(img))
              }, [
                _createVNode(_component_el_icon, { class: "el-icon-delete" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DeleteFilled)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_9), [
                [_vShow, _ctx.imgHover[idx]]
              ])
            ], 40, _hoisted_8))
          }), 128)),
          _withDirectives(_createElementVNode("li", _hoisted_10, [
            _createVNode(_component_el_upload, {
              class: "avatar-uploader",
              action: _ctx.uploader,
              data: _ctx.imgOptions,
              "show-file-list": false,
              "before-upload": _ctx.beforeAvatarUpload,
              "on-success": _ctx.handleAvatarSuccess
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Plus)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["action", "data", "before-upload", "on-success"])
          ], 512), [
            [_vShow, _ctx.srcList.length < 2]
          ])
        ]),
        _createVNode(_component_el_alert, {
          title: "※ 4MB以下のJPG、PNG、または、PDF形式",
          type: "info",
          closable: false
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "削除確認",
      modelValue: _ctx.isShowConf,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShowConf) = $event)),
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_11, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowConf = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("いいえ")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.deleteImage
          }, {
            default: _withCtx(() => [
              _createTextVNode("はい")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.delImg.msg) + "を削除していいですか？", 1)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}